export default __webpack_public_path__ + "static/ccl-d853f81799a1acd02297db4331a15d38.webm";